import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const SlackIcon = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        style: style,
        className: className,
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6.22002 14.64C6.22002 15.8 5.28002 16.74 4.12002 16.74C2.96002 16.74 2.02002 15.8 2.02002 14.64C2.02002 13.48 2.96002 12.54 4.12002 12.54H6.22002V14.64ZM7.27002 14.64C7.27002 13.48 8.21002 12.54 9.37002 12.54C10.53 12.54 11.47 13.48 11.47 14.64V19.89C11.47 21.05 10.53 21.99 9.37002 21.99C8.21002 21.99 7.27002 21.05 7.27002 19.89V14.64Z",
                fill: "#E01E5A"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.37 6.21001C8.21 6.21001 7.27 5.27001 7.27 4.11001C7.27 2.95001 8.21 2.01001 9.37 2.01001C10.53 2.01001 11.47 2.95001 11.47 4.11001V6.21001H9.37ZM9.37 7.27001C10.53 7.27001 11.47 8.21001 11.47 9.37001C11.47 10.53 10.53 11.47 9.37 11.47H4.1C2.94 11.47 2 10.53 2 9.37001C2 8.21001 2.94 7.27001 4.1 7.27001H9.37Z",
                fill: "#36C5F0"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.78 9.37C17.78 8.21 18.72 7.27 19.88 7.27C21.04 7.27 21.98 8.21 21.98 9.37C21.98 10.53 21.04 11.47 19.88 11.47H17.78V9.37ZM16.73 9.37C16.73 10.53 15.79 11.47 14.63 11.47C13.47 11.47 12.53 10.53 12.53 9.37V4.1C12.53 2.94 13.47 2 14.63 2C15.79 2 16.73 2.94 16.73 4.1V9.37Z",
                fill: "#2EB67D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.63 17.79C15.79 17.79 16.73 18.73 16.73 19.89C16.73 21.05 15.79 21.99 14.63 21.99C13.47 21.99 12.53 21.05 12.53 19.89V17.79H14.63ZM14.63 16.74C13.47 16.74 12.53 15.8 12.53 14.64C12.53 13.48 13.47 12.54 14.63 12.54H19.9C21.06 12.54 22 13.48 22 14.64C22 15.8 21.06 16.74 19.9 16.74H14.63Z",
                fill: "#ECB22E"
            })
        ]
    });
};
